export const generateTextColor = (red, green, blue) => {
  const brightnessScore = red * 0.299 + green * 0.587 + blue * 0.114
  return brightnessScore > 186 ? '#1a1a1a' : '#ffffff'
}
